/**
 * Labstep
 *
 * @module components/EntityState/Form/ShowEdit/TargetAllowedActionsLock
 * @desc Update EntityState targetAllowedActionsLock
 */

import {
  fieldEntityStateTargetAllowedActionsLock,
  type LOCK_SETTINGS_KEYS,
} from 'labstep-web/components/EntityState/Form/fields';
import { FormShowEditSelect as ShowEditSelect } from 'labstep-web/core/Form/ShowEdit/Select';
import { TARGET_ALLOWED_ACTIONS_LOCK_OPTIONS } from 'labstep-web/models/entity-state.model';
import isEqual from 'lodash/isEqual';
import type React from 'react';
import type { EntityStateFormShowEditTargetAllowedActionsLockProps } from './types';

export const EntityStateFormShowEditTargetAllowedActionsLock: React.FC<
  EntityStateFormShowEditTargetAllowedActionsLockProps
> = ({ entityState }) => (
  <ShowEditSelect
    entity={entityState}
    field={fieldEntityStateTargetAllowedActionsLock}
    name="permitted actions"
    isClearable={false}
    preSubmit={(values) => {
      const option =
        TARGET_ALLOWED_ACTIONS_LOCK_OPTIONS[
          values[
            fieldEntityStateTargetAllowedActionsLock.name as LOCK_SETTINGS_KEYS
          ] as LOCK_SETTINGS_KEYS
        ];
      const body = {
        [fieldEntityStateTargetAllowedActionsLock.name]:
          option.target_allowed_actions_lock,
        is_lock: option.is_lock,
      };

      return body;
    }}
  >
    {Object.keys(TARGET_ALLOWED_ACTIONS_LOCK_OPTIONS).find((key) =>
      isEqual(
        TARGET_ALLOWED_ACTIONS_LOCK_OPTIONS[key as LOCK_SETTINGS_KEYS]
          .permissions,
        entityState.target_allowed_actions_lock,
      ),
    )}
  </ShowEditSelect>
);
